import React from 'react'
import Snackbar from 'material-ui/Snackbar'
import { inject,observer } from 'mobx-react'
import T from 'i18n-react'


@inject('messenger') @observer
class Messenger extends React.Component {
  render () {
    const messenger = this.props.messenger,
          m = "messenger." + messenger.currentMessage,
          msg = T.translate(m)

    let open = messenger.open ? messenger.open : false

    return (
      <Snackbar
       anchorOrigin={{vertical:"bottom",horizontal:"right"}}
       open={open}
       autoHideDuration={2000}
       onClose={messenger.handleClose}
       message={<span id="message-id"> {msg} </span>}
      />
    )

  }
}


export default Messenger



// WEBPACK FOOTER //
// ./src/components/messenger.js